import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';

@Component({
    selector: 'bs-linear-single-bet-general-stake-container',
    templateUrl: './linear-single-bet-general-stake-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./linear-single-bet-general-stake-container.component.scss'],
    standalone: false,
})
export class LinearSingleBetGeneralStakeContainerComponent {
    private readonly linearMessages = inject(Sitecore).betslip.linear;

    readonly picksCount = input.required<number>();

    readonly stakeAllSelectionsInfo = this.linearMessages.StakeAllSelections;

    readonly stakeAllSelectionsTitle = computed(() => {
        const count = this.picksCount();
        const title = this.linearMessages.StakeAllSelectionsTitle;

        return interpolateDoubleBracesString(title, { count });
    });
}
